module.exports = __webpack_public_path__ + "img/nsp.41061e9.png";